import React from 'react';
import { t } from 'i18next';
import { ActiveDotIcon, CloseIcon, InactiveDotIcon } from '../../asset';
import { Timeline } from 'antd';
import style from '../../page/admin/user/userPage.module.css'

const UserManagement = ({ drawer, closeDrawer }) => {

  return (
    <aside className={drawer ? "duration-300 ease-out transition-all right-0 w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)]" : "duration-300 ease-out transition-all right-[-400px] w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)]"}>
        <button className='absolute top-[21px] right-[21px]' onClick={closeDrawer}>
          <img src={CloseIcon} alt="" />
        </button>

        <h3 className='font-sans-bold text-[#1D1D1D] text-[20px]'>{t("USER_DETAIL:DATA_MANAGEMENT_HISTORY")}</h3>
        <p className='font-sans text-[#818181] text-[12px] mb-[24px]'>{t("USER_DETAIL:CREATED_BY")} <strong>Udin Jamaludin</strong> {t("USER_DETAIL:ON")} <strong>01/02/2022</strong></p>

        <div className={style.timelineContainer}>
          <Timeline>
            <Timeline.Item dot={<img src={ActiveDotIcon} />}>
              <div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
                <h4 className={"text-[#CF0000]font-roboto-medium text-[14px]"}>{t("USER_DETAIL:LAST_MODIFIED")}</h4>
                <h4 className='font-roboto-medium text-[14px] text-[#424242]'>Tubagus Tamma</h4>
                <p>01/02/2022 • 13:45 PM</p>
              </div>
            </Timeline.Item>
            <Timeline.Item dot={<img src={InactiveDotIcon} />}>
              <div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
                <h4 className={"font-roboto-medium text-[14px]"}>{t("USER_DETAIL:MODIFIED")}</h4>
                <h4 className='font-roboto-medium text-[14px] text-[#424242]'>Tubagus Tamma</h4>
                <p>01/02/2022 • 13:45 PM</p>
              </div>
            </Timeline.Item>
            <Timeline.Item dot={<img src={InactiveDotIcon} />}>
              <div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
                <h4 className={"font-roboto-medium text-[14px]"}>{t("USER_DETAIL:MODIFIED")}</h4>
                <h4 className='font-roboto-medium text-[14px] text-[#424242]'>Tubagus Tamma</h4>
                <p>01/02/2022 • 13:45 PM</p>
              </div>
            </Timeline.Item>
            <Timeline.Item dot={<img src={InactiveDotIcon} />}>
              <div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
                <h4 className={"font-roboto-medium text-[14px]"}>{t("USER_DETAIL:MODIFIED")}</h4>
                <h4 className='font-roboto-medium text-[14px] text-[#424242]'>Tubagus Tamma</h4>
                <p>01/02/2022 • 13:45 PM</p>
              </div>
            </Timeline.Item>
          </Timeline>
        </div>
      </aside>
  );
}

export default UserManagement;